import { calloutTypes } from "./constants";
import { CalloutType } from "./types";
export const calloutNodes = {
    callout: {
        group: "block",
        content: "block+",
        defining: true,
        selectable: false,
        isolating: true,
        attrs: {
            type: { default: CalloutType.info },
        },
        parseDOM: [
            {
                tag: "div[data-callout]",
                getAttrs: (dom) => {
                    const type = dom.getAttribute("data-callout");
                    return calloutTypes.includes(type) ? { type } : false;
                },
            },
        ],
        toDOM: (node) => {
            const attrs = node.attrs;
            return [
                "div",
                { class: `callout callout--${attrs.type}`, "data-callout": attrs.type },
                ["div", { class: "callout__content" }, 0],
            ];
        },
    },
};
